<template>
  <span style="font-size:30px;cursor:pointer" @click="toggleSidenav">
    &#9776;
  </span>
</template>

<script>
  export default {
    name: 'Toggler',
    methods: {
      toggleSidenav: function(){
        document.body.classList.toggle("show-sidenav");
      },
    }
  }
</script>
